import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-sokusai-forgot-password',
  templateUrl: './sokusai-forgot-password.component.html',
  styleUrls: ['../style/global.css', './sokusai-forgot-password.component.css'],
})
export class SokusaiForgotPasswordComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}

  get logoUrl() {
    return (
      environment.apps[this.clientId].oemConfig?.imgpath ||
      '/assets/wellnesscloud/images/logo.svg'
    );
  }
}
